/* Shared behaviour for the lower bangle product page sections. Loaded by every
   section that needs it; the guard makes repeated loads a no-op. */
(function () {
  if (window.bangleSectionsReady) return;
  window.bangleSectionsReady = true;

  var reduceMotion = function () {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  /* "Scroll to the buy box" links: any element with data-scroll-to-buybox. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-scroll-to-buybox]');
    if (!link) return;
    var target =
      document.querySelector('product-info bangle-tiers') ||
      document.querySelector('product-info .bangle-buybox') ||
      document.querySelector('product-info');
    if (!target) return;
    event.preventDefault();
    var top = target.getBoundingClientRect().top + window.pageYOffset - 24;
    window.scrollTo({ top: top, behavior: reduceMotion() ? 'auto' : 'smooth' });
    var focusable = target.querySelector('input, button, a');
    if (focusable) focusable.focus({ preventScroll: true });
  });

  /* Count-up for the stats band. Only pure integers animate; anything else is
     left exactly as rendered. */
  if (!customElements.get('bangle-stats')) {
    customElements.define(
      'bangle-stats',
      class BangleStats extends HTMLElement {
        connectedCallback() {
          this.numbers = Array.from(this.querySelectorAll('[data-count]'));
          if (!this.numbers.length || reduceMotion() || !('IntersectionObserver' in window)) return;
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.observer.disconnect();
              this.numbers.forEach((el) => this.animate(el));
            },
            { threshold: 0.3 }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        animate(el) {
          var raw = el.textContent.trim();
          if (!/^\d{1,6}$/.test(raw)) return;
          if (document.visibilityState !== 'visible') return;
          var target = parseInt(raw, 10);
          var duration = 900;
          var start = null;
          var done = false;
          var finish = () => {
            done = true;
            el.textContent = raw;
          };
          var step = (timestamp) => {
            if (done) return;
            if (start === null) start = timestamp;
            var progress = Math.min((timestamp - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = String(Math.round(target * eased));
            if (progress < 1) window.requestAnimationFrame(step);
            else finish();
          };
          window.requestAnimationFrame(step);
          /* Frames stop in background tabs; never leave a 0 on screen. */
          window.setTimeout(finish, duration + 300);
        }
      }
    );
  }
})();
